<!-- Nova versão (pills + select) — quando isNewHomePedirDelivery -->
<ng-container *ngIf="isNewHomePedirDelivery">
	<div *ngIf="!stickyMode" #pillsWrapper class="category-pills-wrapper">
		<div class="category-pills">
			<button
				*ngIf="!itemsToHide?.featuredItems"
				type="button"
				class="category-pill"
				[class.category-pill--active]="categoryToScroll === 'featuredItems'"
				(click)="selectCategory('featuredItems')"
			>{{ 'On Sale' | translate }}</button>
			<!-- Combos, pizzas e categorias na ordem da tela (ver `navEntries`). -->
			<ng-container *ngFor="let entry of navEntries; trackBy: trackByEntry">
				<button
					*ngIf="isEntryVisible(entry)"
					type="button"
					class="category-pill"
					[class.category-pill--active]="categoryToScroll === entry.value"
					(click)="selectCategory(entry.value)"
				>{{ entryLabel(entry) }}</button>
			</ng-container>
		</div>
	</div>

	<!-- Select (quando a barra está fixa no topo) -->
	<div *ngIf="stickyMode" class="category-select-wrapper">
		<select
			class="category-select"
			[id]="selectId"
			[(ngModel)]="categoryToScroll"
			(change)="onSelectChange($event)"
		>
			<option value="scroll-to-top">↑ {{ 'Back to top' | translate }}</option>
			<option *ngIf="!itemsToHide?.featuredItems" value="featuredItems">{{ 'On Sale' | translate }}</option>
			<ng-container *ngFor="let entry of navEntries; trackBy: trackByEntry">
				<option *ngIf="isEntryVisible(entry)" [value]="entry.value">{{ truncate(entryLabel(entry)) }}</option>
			</ng-container>
		</select>
	</div>
</ng-container>

<!-- Original (master) — RECRIADO sem Ionic: ion-segment → barra horizontal scrollável de
     <button>; ion-label → span. Reaproveita selectCategory() (set categoryToScroll + emit). -->
<ng-container *ngIf="!isNewHomePedirDelivery">
	<div id="categoryNav" class="mp-segment sticky">
		<button type="button" *ngIf="!itemsToHide.featuredItems" id="featuredItems-category" class="mp-segment-button" [class.mp-segment-button--active]="categoryToScroll === 'featuredItems'" (click)="selectCategory('featuredItems'); selectedCategory = 'featuredItems'; categoryToCentralizeInNav = 'featuredItems-category'">
			<span class="mp-segment-label">{{ 'On Sale' | translate }}</span>
		</button>
		<ng-container *ngFor="let entry of navEntries; trackBy: trackByEntry">
			<button type="button" *ngIf="isEntryVisible(entry)" [id]="entry.legacyId" class="mp-segment-button" [class.mp-segment-button--active]="categoryToScroll === entry.value" (click)="selectLegacyEntry(entry)">
				<span class="mp-segment-label">{{ entryLabel(entry) }}</span>
			</button>
		</ng-container>
	</div>
</ng-container>
